module.exports = __webpack_public_path__ + "fonts/Poppins-Medium.f88c443f.otf";